import { useNonHookTrans } from "~/hooks/useTrans";

export function setSEO(pageTitle: string) {
	const { trans } = useNonHookTrans();

	document.title = trans(pageTitle, {
		title: trans("seo.title.main"),
	});
}

export function setDesc() {
	const meta = document.querySelector("meta[name='description']");

	if (meta) {
		const { trans } = useNonHookTrans();

		meta.setAttribute("content", trans("seo.desc"));
	}
}
